import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './NouriaSupport.css';

export const NOURIA_SUPPORT_EMAIL = 'nouriasupport@thepantry.life';

export default function NouriaSupport() {
  useEffect(() => {
    document.title = 'Nouria Support';
    return () => { document.title = 'The Pantry Life'; };
  }, []);

  return (
    <div className="nouria-container">
      <div className="nouria-prose">
        <span className="nouria-overline">Nouria</span>
        <h1>Support</h1>
        <p className="nouria-page-meta">How to get help, and answers to the common questions.</p>

        <div className="nouria-card nouria-card--mint nouria-contact">
          <span className="nouria-overline">Email</span>
          <p className="nouria-contact-address">{NOURIA_SUPPORT_EMAIL}</p>
          <p className="nouria-secondary nouria-body-small">
            Write to <a href={`mailto:${NOURIA_SUPPORT_EMAIL}`}>{NOURIA_SUPPORT_EMAIL}</a> and a
            person will read it. We aim to reply within two working days.
          </p>
        </div>

        <h2>What Nouria does, and does not do</h2>
        <p>
          Nouria reads supplement labels and blood test letters, charts the results over time,
          and answers questions about your own records. It is informational. It does not
          diagnose, and it never advises on starting, stopping or changing medication.
        </p>
        <p>
          Anything urgent is a matter for the emergency services. In the UK, call 999 in an
          emergency, or NHS 111 if you need help now and it is not an emergency.
        </p>

        <h2>Where your data lives</h2>
        <p>
          Everything is on your phone. Nouria has no accounts, so there is nothing to sign in
          to and no password to recover. There is no server-side copy of your records: if you
          delete the app, the records go with it, and we cannot restore them.
        </p>

        <h2>Subscriptions</h2>
        <p>
          Nouria Plus is <span className="nouria-num">£5.99</span> a month, billed through Apple.
          There is no annual plan.
        </p>
        <ul>
          <li>
            To manage or cancel, open iOS <strong>Settings</strong>, tap your name, then
            <strong> Subscriptions</strong>, and choose Nouria.
          </li>
          <li>
            Refunds are handled by Apple, not by us. Request one at{' '}
            <a href="https://reportaproblem.apple.com" target="_blank" rel="noopener noreferrer">
              reportaproblem.apple.com
            </a>.
          </li>
        </ul>

        <h2>Health app permissions</h2>
        <p>
          With your permission, Nouria reads heart rate, heart rate variability, sleep,
          weight, steps, blood pressure and glucose from the Health app, so they can sit
          beside your results. It writes nothing to the Health app.
        </p>
        <p>
          To change what Nouria can read, open the <strong>Health</strong> app, tap your
          picture, then <strong>Sharing</strong>, then <strong>Apps</strong>, and choose Nouria.
        </p>

        <h2>Deleting your data</h2>
        <p>
          Removing a record in the app deletes it and its photographs. Deleting the app
          removes everything. Because nothing is held on our side, there is nothing further
          for us to erase.
        </p>

        <h2>Something is not working</h2>
        <p>
          Close Nouria and open it again. If the problem stays, delete and reinstall the app
          from the App Store, remembering that this removes your records, because they only
          exist on the phone. If it still misbehaves, email us with what you tapped and what
          you saw, and we will look into it.
        </p>

        <h2>Privacy</h2>
        <p>
          How Nouria handles your data is set out in the{' '}
          <Link to="/nouria/privacy">privacy policy</Link>.
        </p>
      </div>
    </div>
  );
}
